import { FilterProvider } from '@/hooks/Filters/filter';
import { Flex } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import fetchDashMenu from '@services/query/fetchDashMenu';
import fetchDashSupergroups from '@services/query/fetchDashSupergroups';

import Board from './components/Board';
import Header from './components/Header';
import { TasksProvider } from './hooks/tasks';

const MonitoringContent = ({
  redirection,
  pdf_export,
  dashMenuOptions,
}: {
  redirection?: any;
  pdf_export?: any;
  dashMenuOptions?: any;
}): JSX.Element => {
  return (
    <FilterProvider
      initialState={{
        status: {
          single: {
            column: 'status',
            selected: 'done',
            table: 'tasks',
            type: 'single',
          },
        },
      }}
      screen="tasks"
    >
      <TasksProvider
        redirection={redirection}
        pdf_export={pdf_export}
        dashMenuOptions={dashMenuOptions}
      >
        <Flex
          flexDir="row"
          overflowY="hidden"
          alignItems="flex-start"
          gap={4}
          flex={1}
          w="full"
        >
          <Board />
        </Flex>
      </TasksProvider>
    </FilterProvider>
  );
};

const TaskIndex = (props: any): JSX.Element => {
  const { redirection, pdf_export } = props;
  const [dashMenuOptions, setDashMenuOptions] = useState<any[]>([]);

  useEffect(() => {
    async function loadMenu() {
      try {
        const supergroups = await fetchDashSupergroups();
        if (supergroups && supergroups.length > 0) {
          const menu = await fetchDashMenu(supergroups[0].id);
          setDashMenuOptions(menu);
        }
      } catch (error) {
        console.error('Failed to fetch dash menu', error);
      }
    }
    loadMenu();
  }, []);
  return (
    <Flex
      h="100vh"
      maxH="100vh"
      px={6}
      py={4}
      bg="gray.50"
      direction="column"
      flex={1}
    >
      <Header />
      <MonitoringContent
        redirection={redirection}
        pdf_export={pdf_export}
        dashMenuOptions={dashMenuOptions}
      />
    </Flex>
  );
};

export default TaskIndex;
